import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import {SortingOptionsValues} from '../tableTypes';

interface TableHeaderCellSortableProps {
    title?: string | JSX.Element;
    isSortActive: boolean;
    sortDirection: SortingOptionsValues | undefined;
    onSort: () => void;
}

TableHeaderCellSortable.defaultProps = {
    title: '',
};

export default function TableHeaderCellSortable(props: TableHeaderCellSortableProps) {
    const {
        title,
        isSortActive,
        sortDirection,
        onSort,
    } = props;
    
    return (
        <TableCell
            key={title as string}
            align="left"
            sortDirection="asc"
        >
            <TableSortLabel
                active={isSortActive}
                direction={sortDirection}
                onClick={onSort}
                IconComponent={ArrowDropUpIcon}
            >
                {title}
            </TableSortLabel>
        </TableCell>
    );
}
